import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AnalyticsService, AuthenticationService, DataService, LoansService, StorageService } from 'src/app/_services';

@Component({
  selector: 'app-update-modal',
  templateUrl: './update-modal.component.html',
  styleUrls: ['./update-modal.component.css']
})
export class UpdateModalComponent implements OnInit {



  @Input() data = null;
  @Input() editableFields = [];
  @Output() close = new EventEmitter();
  @Output() updateData = new EventEmitter();
  currentUser: any;
  updateForm: any



  constructor(
    public loansService: LoansService,
    public analyticsService: AnalyticsService,
    public storageService: StorageService,
    private dataService: DataService,
    public authService: AuthenticationService,
    private router: Router,
    private fb: FormBuilder,
  ) { 
    this.currentUser = this.storageService.read<any>('currentUser');
  }

  ngOnInit() {
    console.log(this.editableFields);
    console.log("Data",this.data);
    this.updateForm = this.fb.group(this.mapindArray())
  }

  mapindArray() {

    let objectDAta = {}
   

    for (let index = 0; index < this.editableFields.length; index++) {
      
      objectDAta[this.editableFields[index]] = this.data.id ?this.data[this.editableFields[index]]:""
   
    }
    return objectDAta
  }

  async submitForm() {
    this.updateData.emit(this.updateForm.value)
    this.closeView()
  }

  closeView() {
    this.close.emit()
  }

}
